import script from "./DailyReconfirmedFollowupsChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyReconfirmedFollowupsChart.vue?vue&type=script&setup=true&lang=js"

import "./DailyReconfirmedFollowupsChart.vue?vue&type=style&index=0&id=0c1e0f6b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c1e0f6b"]])

export default __exports__